import React from 'react';
import {Button} from 'reactstrap';
import {AvForm} from 'availity-reactstrap-validation';
import PropTypes from 'prop-types';
import Translate from "../../shared/language/Translate";
import GeneralUtils from "../../shared/utils/GeneralUtils";
import {TabPanel, TabView} from 'primereact/tabview';
import DataTableWithButton from "../../shared/component/dataTable/DataTableWithButton";
import OrderItemsColumn from "../../shared/component/dataTable/columns/OrderItemsColumn.json";
import OrderService from "../../shared/service/OrderService";
import Loading from "../../shared/component/others/Loading";
import MerchantUserService from "../../shared/service/MerchantUserService";
import ModalConfirm from "../../shared/component/dialog/ModalConfirm";
import FormSection from "../../shared/component/form/FormSection";
import {OrderDetailTabFields, OrderErrorFields, OrderMoreTabFields} from "./OrderDetailFields";
import '../../shared/styles/SettingsPage.css';

const defaultOrder = {
    id: null,
    orderNo: null,
    orderDate: null,
    basketStatus: null,
    syncStatus: null,
    orderStatus: null,
    acceptedDate: null,
    preparingDate: null,
    readyDate: null,
    deliveredDate: null,
    totalPrice: null,
    orderType: null,
    errorType: "INIT",
    errorMessage: null,
    basketDetailList: []
};
export default class OrdersDetail extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            order: defaultOrder, pageMode: null, loading: false, driverList: []
        }
        this.orderService = new OrderService();
        this.merchantUserService = new MerchantUserService();
    }

    componentDidMount() {
        this.merchantUserService.getDrivers().then(response => this.setState({
            driverList: response
        }));
    }

    render() {
        return (
            <div className="settings-page settings-page--dialog settings-page--order-detail">
                <ModalConfirm header='Warning' ok='OK' onOkClick={this.refund}
                              onCancelClick={() => this.setState({displayShowStatusConfirmDialog: false})}
                              show={this.state.displayShowStatusConfirmDialog}
                              message={this.state.noticeResponse}/>
                <AvForm>
                        <div className="settings-page--order-detail__body">
                        <TabView className="settings-page__tabs">
                            <TabPanel header="Order Detail">
                                <div className="settings-page__tab-panel">
                                <FormSection>
                                    <OrderDetailTabFields
                                        order={this.state.order}
                                        showBasketType={false}
                                        variant="open"
                                        driverList={this.state.driverList}
                                        onDriverChange={this.__handleChange}
                                    />
                                </FormSection>
                                </div>
                            </TabPanel>
                            <TabPanel header="More">
                                <div className="settings-page__tab-panel">
                                <FormSection>
                                    <OrderMoreTabFields order={this.state.order}/>
                                </FormSection>
                                </div>
                            </TabPanel>
                        </TabView>


                        {(this.state.order.errorType == "PRINTER" || this.state.order.errorType == "TABLE_NOT_FOUND") &&
                            <FormSection title="Error Details">
                                <OrderErrorFields order={this.state.order}/>
                            </FormSection>}

                        <FormSection>
                            <div className="settings-page__table-wrap settings-page__table-wrap--order-items">
                                <DataTableWithButton data={this.state.order.basketDetailList}
                                                     className="order-detail-items-table"
                                                     ref={(elem) => this.refDataTable = elem}
                                                     selectionMode='single'
                                                     paginator={false}
                                                     fields={OrderItemsColumn.fields}/>
                            </div>
                        </FormSection>
                        </div>

                        <div className="settings-page__order-detail-actions">

                            {GeneralUtils.isClerk() && this.state.order.orderStatus == "ORDER_PLACED" &&
                                <Button color="outline-primary" className="settings-page__btn--action settings-page__btn--wrap"
                                        onClick={() => {
                                            this.accept();
                                        }}>
                                    <Translate contentKey="entity.action.add">Accept Order</Translate>
                                </Button>}

                            {GeneralUtils.isClerk() && this.state.order.orderStatus == "ORDER_ACCEPTED" && this.state.order.basketStatus == 'CANCELLED' &&
                                <Button color="outline-primary" className="settings-page__btn--action settings-page__btn--wrap"
                                        onClick={() => {
                                            this.decline();
                                        }}>
                                    <Translate contentKey="entity.action.add">Decline Order</Translate>
                                </Button>}

                            {GeneralUtils.isClerk() && this.state.order.orderStatus == "ORDER_PLACED" &&
                                <Button color="outline-danger" className="settings-page__btn--delete settings-page__btn--wrap"
                                        onClick={() => {
                                            this.decline();
                                        }}>
                                    <Translate contentKey="entity.action.add">Decline Order</Translate>
                                </Button>}

                            {GeneralUtils.isClerk() && this.state.order.clientAgent != "WEB" && this.state.order.orderStatus == "ORDER_DELIVERED" && this.state.order.basketStatus == 'PAUSED' &&
                                <Button color="outline-danger" className="settings-page__btn--delete settings-page__btn--wrap"
                                        onClick={() => {
                                            this.decline();
                                        }}>
                                    <Translate contentKey="entity.action.add">Decline Order</Translate>
                                </Button>}

                            {GeneralUtils.isKitchen() && this.state.order.orderStatus == "ORDER_ACCEPTED" && this.state.order.basketStatus != 'CANCELLED' &&
                                <Button color="outline-primary" className="settings-page__btn--action settings-page__btn--wrap"
                                        onClick={() => {
                                            this.preparing();
                                        }}>
                                    <Translate contentKey="entity.action.add">Preparing Order</Translate>
                                </Button>}

                            {GeneralUtils.isKitchen() && this.state.order.orderStatus == "ORDER_PREPARING" &&
                                <Button color="outline-primary" className="settings-page__btn--action settings-page__btn--wrap"
                                        onClick={() => {
                                            this.ready();
                                        }}>
                                    <Translate contentKey="entity.action.add">Order Ready</Translate>
                                </Button>}

                            {GeneralUtils.isWaiter() && this.state.order.orderStatus == "ORDER_READY" && (this.state.order.orderType == "EAT_IN" || this.state.order.orderType == "COLLECTION" || this.state.order.orderType == "TAKEAWAY") &&
                                <Button color="outline-primary" className="settings-page__btn--action settings-page__btn--wrap"
                                        onClick={() => {
                                            this.deliver();
                                        }}>
                                    <Translate contentKey="entity.action.add">Deliver Order</Translate>
                                </Button>}

                            {(this.state.order.basketStatus != "INPROGRESS") && this.state.order.orderStatus == "ORDER_DISPATCHED" && this.state.order.orderType == "DELIVERY" &&
                                <Button color="outline-primary" className="settings-page__btn--action settings-page__btn--wrap"
                                        onClick={() => {
                                            this.deliver();
                                        }}>
                                    <Translate contentKey="entity.action.add">Order Delivered</Translate>
                                </Button>}

                            {((GeneralUtils.isClerk() && this.state.order.clientAgent == "WEB" && (this.state.order.basketStatus == "INPROGRESS") && (this.state.order.orderStatus == "ORDER_DELIVERED")) ||
                                (GeneralUtils.isDriver() && this.state.order.clientAgent == "WEB" && (this.state.order.basketStatus == "INPROGRESS") && (this.state.order.orderStatus == "ORDER_DISPATCHED"))) &&
                                <Button color="outline-primary" className="settings-page__btn--action settings-page__btn--wrap"
                                        onClick={() => {
                                            this.payByCardOrCash("CARD");
                                        }}>
                                    <Translate contentKey="entity.action.add">Pay By Card</Translate>
                                </Button>}

                            {((GeneralUtils.isClerk() && this.state.order.clientAgent == "WEB" && (this.state.order.basketStatus == "INPROGRESS") && (this.state.order.orderStatus == "ORDER_DELIVERED")) ||
                                (GeneralUtils.isDriver() && this.state.order.clientAgent == "WEB" && (this.state.order.basketStatus == "INPROGRESS") && (this.state.order.orderStatus == "ORDER_DISPATCHED"))) &&
                                <Button color="outline-primary" className="settings-page__btn--action settings-page__btn--wrap"
                                        onClick={() => {
                                            this.payByCardOrCash("CASH");
                                        }}>
                                    <Translate contentKey="entity.action.add">Pay By Cash</Translate>
                                </Button>}

                            {GeneralUtils.isClerk() && this.state.order.orderStatus == "ORDER_READY" && this.state.order.orderType == "DELIVERY" &&
                                <Button color="outline-primary" className="settings-page__btn--action settings-page__btn--wrap"
                                        onClick={() => {
                                            this.dispatch();
                                        }}>
                                    <Translate contentKey="entity.action.add">Dispatch Order</Translate>
                                </Button>}

                            {GeneralUtils.isClerk() &&
                                <Button color="outline-primary" className="settings-page__btn--action settings-page__btn--wrap"
                                        onClick={() => {
                                            this.resendToKitchen();
                                        }}>
                                    <Translate contentKey="entity.action.add">Print Order</Translate>
                                </Button>}

                            {GeneralUtils.isClerk() && this.state.order.orderStatus != "ORDER_PLACED" &&
                                <Button color="outline-primary" className="settings-page__btn--action settings-page__btn--wrap"
                                        onClick={() => {
                                            this.printReceipt();
                                        }}>
                                    <Translate contentKey="entity.action.add">Print Receipt</Translate>
                                </Button>}

                            {GeneralUtils.isClerk() && this.state.order.clientAgent == "WEB" && (this.state.order.orderStatus == "ORDER_CLOSED") && (this.state.order.syncStatus == "PROGRESS" || this.state.order.syncStatus == "FAILED") &&
                                <Button color="outline-primary" className="settings-page__btn--action settings-page__btn--wrap"
                                        onClick={() => {
                                            this.changeSyncStatusSuccess();
                                        }}>
                                    <Translate contentKey="entity.action.add">Finalise Order</Translate>
                                </Button>}

                            {GeneralUtils.isClerk() && this.state.order.clientAgent == "WEB" && (this.state.order.basketStatus == "PAID") && (this.state.order.orderStatus == "ORDER_ACCEPTED" || this.state.order.orderStatus == "ORDER_PREPARING" || this.state.order.orderStatus == "ORDER_READY" || this.state.order.orderStatus == "ORDER_DISPATCHED") &&
                                <Button color="outline-danger" className="settings-page__btn--delete settings-page__btn--wrap"
                                        onClick={() => {
                                            this.showChangeStatusConfirmDialog(true)
                                        }}>
                                    <Translate contentKey="entity.action.add">Refund</Translate>
                                </Button>}

                            <Button color="outline-primary" className="settings-page__btn--cancel settings-page__btn--close"
                                    onClick={() => {
                                        this.props.closeDisplayDialog();
                                    }}>
                                <Translate contentKey="entity.action.cancel">Close</Translate>
                            </Button>
                        </div>
                </AvForm>
                {this.state.loading && <Loading/>}

            </div>);
    }

    accept = () => {
        this.setState({loading: true});
        if (!GeneralUtils.isNullOrEmpty(this.state.order.id)) {
            this.orderService.acceptOrder(this.state.order.id).then((response) => {
                if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                    this.props.refreshDataTable();
                }
                this.setState({loading: false});
            });
        }

    }

    showChangeStatusConfirmDialog = (value) => {
        this.setState({
            displayShowStatusConfirmDialog: true,
            noticeResponse: "Are you sure to refund?"
        });
    }

    printReceipt = () => {
        this.setState({loading: true});
        if (!GeneralUtils.isNullOrEmpty(this.state.order.id)) {
            this.orderService.printReceipt(this.state.order.id).then((response) => {
                if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                    this.props.closeDisplayDialog();
                }
                this.setState({loading: false});
            });
        }

    }

    changeSyncStatusSuccess = () => {
        this.setState({loading: true});
        if (!GeneralUtils.isNullOrEmpty(this.state.order.id)) {
            this.orderService.changeSyncStatusSuccess(this.state.order.id).then((response) => {
                if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                    this.props.refreshDataTable();
                }
                this.setState({loading: false});
            });
        }

    }

    preparing = () => {
        this.setState({loading: true});
        if (!GeneralUtils.isNullOrEmpty(this.state.order.id)) {
            this.orderService.preparingOrder(this.state.order.id).then((response) => {
                if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                    this.props.refreshDataTable();
                }
                this.setState({loading: false});
            });
        }

    }

    ready = () => {
        this.setState({loading: true});
        if (!GeneralUtils.isNullOrEmpty(this.state.order.id)) {
            this.orderService.readyOrder(this.state.order.id).then((response) => {
                if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                    this.props.refreshDataTable();
                }
            });
            this.setState({loading: false});
        }

    }

    deliver = () => {
        this.setState({loading: true});
        if (!GeneralUtils.isNullOrEmpty(this.state.order.id)) {
            this.orderService.deliverOrder(this.state.order.id).then((response) => {
                if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                    this.props.refreshDataTable();
                }
                this.setState({loading: false});
            });
        }

    }

    dispatch = () => {
        let driverId = -1;
        if(!GeneralUtils.isNullOrEmpty(this.state.order.driverId)){
            driverId = this.state.order.driverId;
        }

        this.setState({loading: true});
        if (!GeneralUtils.isNullOrEmpty(this.state.order.id)) {
            this.orderService.dispatchOrder(this.state.order.id, driverId).then((response) => {
                if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                    this.props.refreshDataTable();
                }
                this.setState({loading: false});
            });
        }


    }

    resendToKitchen = () => {
        this.setState({loading: true});
        if (!GeneralUtils.isNullOrEmpty(this.state.order.id)) {
            this.orderService.resendToKitchen(this.state.order.id).then((response) => {
                if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                    this.props.refreshDataTable();
                }
                this.setState({loading: false});
            });
        }

    }

    refund = () => {
        this.setState({loading: true});
        if (!GeneralUtils.isNullOrEmpty(this.state.order.id)) {
            this.orderService.refund(this.state.order.id).then((response) => {
                if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                    this.props.refreshDataTable();
                }
                this.setState({loading: false, displayShowStatusConfirmDialog: false});
            });
        }

    }

    payByCardOrCash = (paymentType) => {
        this.setState({loading: true});
        if (!GeneralUtils.isNullOrEmpty(this.state.order.id)) {
            this.orderService.getManuelPayment(this.state.order.id, paymentType).then((response) => {
                if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                    this.props.refreshDataTable();
                }
                this.setState({loading: false});
            });
        }

    }

    decline = () => {
        this.setState({loading: true});
        if (!GeneralUtils.isNullOrEmpty(this.state.order.id)) {
            this.orderService.declineOrder(this.state.order.id).then((response) => {
                if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                    this.props.refreshDataTable();
                }
                this.setState({loading: false});
            });
        }

    }


    setData = (data) => {
        this.setState({order: data});
    }

    clearData = () => {
        let obj = Object.assign({}, defaultOrder);
        this.setState({order: obj});
    }


    __handleChange = (e) => {
        let value = e.target.parsedValue !== undefined ? e.target.parsedValue : e.target.value;
        let order = this.state.order;
        order[e.target.name] = value;
        this.setState({order: order});
    }

}

OrdersDetail.propTypes = {
    order: PropTypes.object
};
